export * from './src/automations-templates-v1-automation-template-automation-templates.context.js';
